import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Complaint, ServiceId, TransactionStatusId } from "@eres/rvsapi/entities";
import * as SSO from "@10x/sso";
import { isEmptyStringOrNull, normaliseMobileNumber } from "@eres/core/dist/StringUtils";
import { RVSApi } from "@eres/rvsapi";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import Strings from "@my-dld/assets/strings";
import MyComplaintsListView from "@my-dld/components/MyRequest/MyComplaintsListView";
import { DateUtil, I8N } from "@eres/core";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { navigate } from "@my-dld/utils/StoreUtils";
import MyComplaintsGridView from "@my-dld/components/MyRequest/MyComplaintsGridView";
import { formatAppDate } from "@my-dld/utils/Utils";

interface Props extends RoutedViewProps {

}

interface State {
	isLoading: boolean;
	complaints: Complaint[];
	isAnyClosed?: boolean;
}

class MyComplaints extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
			complaints: [],
		};
	}

	componentDidMount() {
		this.loadMyComplaints();
	}

	render() {
		const { isLoading, complaints } = this.state;
		return <React.Fragment>
			<ListGridDataView
				isLoading={ isLoading }
				dataAvailable={ complaints.length > 0 }
				title={ Strings.my_complaints }
				renderListView={ this.renderListView }
				renderGridView={ this.renderGridView }/>
		</React.Fragment>;
	}

	private renderListView = () => {
		const { complaints, isAnyClosed } = this.state;
		return <MyComplaintsListView
			isAnyClosed={ isAnyClosed }
			items={ complaints }
			onDetails={ this.onDetails }/>;
	};

	private renderGridView = () => {
		const { complaints, isAnyClosed } = this.state;
		return <MyComplaintsGridView
			isAnyClosed={ isAnyClosed }
			items={ complaints }
			onDetails={ this.onDetails }/>;
	};

	private loadMyComplaints() {
		let mobile = SSO.getMobileNumber();
		mobile = mobile ? normaliseMobileNumber( mobile ) : "";
		if ( mobile && !isEmptyStringOrNull( mobile ) && mobile.length === 12 ) {
			RVSApi.loadComplaints( mobile, ServiceId.OnlineComplain ).then( ( resp: any ) => {
				const requests = ( resp && resp.Result ) ? resp.Result : [];
				this.setState( {
					isLoading: false,
					complaints: requests,
					isAnyClosed: requests.find( ( complaint: Complaint ) =>
						complaint.TransactionStatusId === TransactionStatusId.Closed ),
				} );
			} ).catch( reason => {
				this.setState( { isLoading: false } );
				showErrorMessage( reason );
			} );
		} else {
			this.setState( { isLoading: false } );
		}
	}

	private onDetails = ( complaint: Complaint ) => {
		trackEventWithData( "RVS", "ViewTransactionDetails",
			{ transactionNo: complaint.TransactionNumber } );
		navigate( `/mydld/mycomplaint/${ complaint.RequestKey }/${ complaint.ShowDownloadComplainButton }` );
	};
}

export function getComplaintTransactionNo( complaint: Complaint ) {
	return complaint.TransactionNumber;
}

export function getComplaintStatus( complaint: Complaint ) {
	return I8N.isRTL() ? complaint.TransactionStatusNameAr : complaint.TransactionStatusNameEn;
}

export function getComplaintDate( complaint: Complaint ) {
	const date = DateUtil.parseDate( complaint.ServiceCreatedDate, "YYYY-MM-DDThh:mm:ss" );
	return formatAppDate( date, "en" );
}

export function getComplaintLicense( complaint: Complaint ) {
	return complaint.LicenseNumber;
}

export function getComplaintAuthority( complaint: Complaint ) {
	return I8N.isRTL() ? complaint.AuthorityNameAr : complaint.AuthorityNameEn;
}

export default MyComplaints;
